import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import router from "./routes/index.js";
import VuejsDialog from 'vuejs-dialog'
import 'vuejs-dialog/dist/vuejs-dialog.min.css'
import './plugins/axios'
import store from './store'

import Common from './services/Common'
import Arrays from './services/Arrays'
import Define from './services/Define'
import BackEnd from './services/BackEnd'

Vue.config.productionTip = false

Vue.use(VuejsDialog)

Vue.prototype.$Arrays = new Arrays()
Vue.prototype.$eventBus = new Vue()
Vue.prototype.$Common = new Common()
Vue.prototype.$Define = Define
Vue.prototype.$BackEnd = new BackEnd()

new Vue({
  vuetify,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
